import { defineStore } from 'pinia'

const useAboutUsStore = defineStore('aboutUs', {
  state: () => ({}),
  actions: {},
})

export default useAboutUsStore
